module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_vm._m(0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activateFrame) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cerrarFrame),
      expression: "cerrarFrame"
    }],
    staticClass: "contenedor-frame"
  }, [_c('div', {
    staticClass: "titulo"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.tituloFrame))]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarFrame
    }
  }, [_c('span', [_vm._v("Cerrar")])])]), _c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])]) : _vm._e()]), (_vm.mostrarModalEliminar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarEliminar",
    on: {
      "close": _vm.closeModalEliminar,
      "do": _vm.eliminarBoleta
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar la boleta con periodo " + _vm._s(_vm.boletaEliminar.periodo) + ", mes " + _vm._s(_vm.boletaEliminar.mes) + ", tipo " + _vm._s(_vm.boletaEliminar.tipo) + ", codigo " + _vm._s(_vm.boletaEliminar.codigo) + "?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar")])]), _c('strong', [_vm._v("Este proceso no se puede deshacer")])])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "filtros-container",
    staticClass: "filtros-container"
  }, [_c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "title-filtro",
    staticClass: "title-filtro",
    class: {
      'hide-box-shadow': !_vm.mostrarFiltros
    },
    on: {
      "click": function($event) {
        _vm.mostrarFiltros = !_vm.mostrarFiltros
      }
    }
  }, [_c('h2', {
    staticClass: "text"
  }, [_vm._v("filtros")]), _c('div', {
    staticClass: "caret"
  }, [_c('span', {
    staticClass: "icon"
  }, [(_vm.mostrarFiltros) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-up"
  })])])]), (_vm.mostrarFiltros) ? _c('div', {
    key: "filtros",
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "codigo-empleado"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Codigo de empleado")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroCodigoEmpleado),
      expression: "filtroCodigoEmpleado"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.filtroCodigoEmpleado)
    },
    on: {
      "focus": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroCodigoEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.filtroCodigoEmpleado = ''
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])])])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaEmpleado) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.filtroCodigoEmpleado
    },
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": function($event) {
        _vm.mostrarBusquedaEmpleado = false
      }
    }
  })], 1) : _vm._e()])], 1)]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Año")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroPeriodo),
      expression: "filtroPeriodo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroPeriodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.periodos), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Mes")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroMes),
      expression: "filtroMes"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroMes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.meses), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Tipo")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroTipo),
      expression: "filtroTipo"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroTipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])]), _c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("¿Visto?")])]), _c('div', {
    staticClass: "select display-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroVisto),
      expression: "filtroVisto"
    }],
    staticClass: "flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroVisto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("No vistas")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Vistas")])])])])]) : _vm._e(), _c('div', {
    key: "boton-container",
    staticClass: "boton-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.limpiarFiltros
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw fa-lg"
  })]), _c('span', [_vm._v("Limpiar")])]), _c('button', {
    staticClass: "button is-primary margin-button-top",
    on: {
      "click": _vm.openModalNotificacionMasiva
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw fa-lg"
  })]), _c('span', [_vm._v("Notificar a todos los filtrados")])])])])], 1), _c('div', {
    key: "body",
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Periodo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Mes")]), _c('th', [_vm._v("Tipo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Visto")]), _c('th')]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table"
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.dni
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Periodo: ")]), _c('span', [_vm._v(_vm._s(o.periodo) + " - " + _vm._s(o.nombreMes))])]), (o.visto) ? [_c('div', {
      staticClass: "show-break-1 seen"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Visto")]), _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check fs-12"
    })])])] : _vm._e()], 2)]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.periodo))]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.nombreMes))]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', {
      staticClass: "text-align-center hide-break-1"
    }, [(o.visto) ? [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])] : [_c('span')]], 2), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.verPdf(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-eye fs-12"
    })]), _c('span', [_vm._v("Ver pdf")])]), (!o.visto) ? _c('button', {
      staticClass: "button is-small margin-left-5",
      attrs: {
        "title": "'Enviar mail al empleado para que vea su boleta'"
      },
      on: {
        "click": function($event) {
          return _vm.notificar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-envelope fs-12"
    })]), _c('span', [_vm._v("Notificar")])]) : _vm._e(), _c('button', {
      staticClass: "button is-small is-danger ml-5",
      on: {
        "click": function($event) {
          return _vm.confirmacionEliminar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash fs-12"
    })]), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay boletas que cumplan con los siguientes filtros")])])])])])]), (_vm.mostrarNotificacionMasiva) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarNotificacionMasiva
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalNotificacionMasiva),
      expression: "closeModalNotificacionMasiva"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Notificacion")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalNotificacionMasiva
    }
  })])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('strong', [_vm._v("¿ Esta seguro de notificar a todos los empleados filtrados?")])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.notificacionMasiva()
      }
    }
  }, [_c('span', [_vm._v("Notificar a todos los filtrados")])]), _c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalNotificacionMasiva
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Reporte de boletas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bcd55c2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Boletas_Reporte_Lista.vue
// module id = 880
// module chunks = 0